// extracted by mini-css-extract-plugin
module.exports = {"container":"paginatorStyle-module--container--Qti9a","active":"paginatorStyle-module--active--bBb5F","inactive":"paginatorStyle-module--inactive--34SCM"};